import { Component, Input, OnInit } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { MessageSeverity } from '../../../enums/message-severity';
import { AppMessage } from '../../../interfaces/app-message';
import { ChatService } from '../../../services/chat/chat.service';
import { ChatResult } from '../../../models/net/result/chat-result';

@Component({
    selector: 'app-app-feed',
    templateUrl: './app-feed.component.html',
    styleUrls: ['./app-feed.component.css']
})

export class AppFeedComponent implements OnInit {

    public severities = MessageSeverity;
    public isShowChatQuestion: boolean = true;
    public chatQuestion: string = "";

    @Input() public dataSource: AppMessage[] = [];

    public constructor(public appService: AppService, public chatService: ChatService) { }

    public ngOnInit(): void {

        this.appService.appFeedPaneToggled.subscribe((isExpanded: boolean) => {

            this.chatQuestion = "";
            this.isShowChatQuestion = isExpanded;
        });
    }

    public buttonClicked = (buttonName: string) => {

        this.appService.addAppFeedMessage(MessageSeverity.Info, "Button " + buttonName + " was clicked...", true);
    }

    public showMessage = (appMessage: AppMessage): void => {

        this.appService.showPendingFeatureDialog();
    }

    public showQuestionInput = (): void => {

    }

    public handleKeyDown = (event: KeyboardEvent) => {

        if (event.key === 'Enter') {

            this.isShowChatQuestion = false;
            this.appService.addAppFeedMessage(MessageSeverity.Info, this.chatQuestion, false);
            this.askQuestion(this.chatQuestion);
        }
    }

    public askQuestion = (question: string): void => {

        this.chatService.ask(question).subscribe((r: ChatResult | null) => {

            if (r) {

                this.appService.addAppFeedMessage(MessageSeverity.Success, r.Answer, false);
            }
        });
    }
}
